
import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

interface ServiceCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  delay?: number;
  link?: string;
}

const ServiceCard: React.FC<ServiceCardProps> = ({ 
  icon, 
  title, 
  description,
  delay = 0,
  link = '#'
}) => {
  return (
    <motion.div
      className="service-card h-full flex flex-col"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ 
        duration: 0.5, 
        delay: delay * 0.1,
        ease: [0.45, 0, 0.2, 1]
      }}
    >
      <div className="p-4 bg-tech-50 rounded-xl w-16 h-16 flex items-center justify-center mb-4 text-tech-600">
        {icon}
      </div>
      <h3 className="text-xl font-semibold mb-2 text-tech-800">{title}</h3>
      <p className="text-muted-foreground flex-grow text-balance mb-4">{description}</p>
      <motion.div
        className="group inline-flex items-center text-tech-600 font-medium"
        whileHover={{ x: 5 }}
        transition={{ duration: 0.2 }}
      >
        <Link to={link} className="inline-flex items-center">
          <span>Add to your bubble</span>
          <ArrowRight className="ml-1 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      </motion.div>
    </motion.div>
  );
};

export default ServiceCard;
